import { Orders } from "./Order";

export const OrderMonitoringReport = {
  "sections": [
    Orders
  ]
}